/** The static bundle is shared by *.bwtr.ai and *.qaso.ai; keep sibling-product links inside the visitor's domain family. */
export function isQasoHost(host = ""): boolean {
  return /^(?:[a-z0-9-]+\.)*qaso\.ai$/.test(host.toLowerCase().split(":")[0] ?? "");
}

const PRODUCT_HOST = /^(secure|assure|soar)\.(bwtr|qaso)\.ai$/;

/** Rewrite a sibling-product URL (secure/assure/soar on either domain) to the visitor's domain family. Everything else is returned unchanged. */
export function domainHref(href: string, host = ""): string {
  if (!/^https:\/\//i.test(href)) return href;
  let url: URL;
  try { url = new URL(href); } catch { return href; }
  const match = PRODUCT_HOST.exec(url.hostname);
  if (!match) return href;
  url.hostname = `${match[1]}.${isQasoHost(host) ? "qaso" : "bwtr"}.ai`;
  return url.href;
}

/** Same as domainHref for the current page; falls back to the source URL outside a browser. */
export function currentDomainHref(href: string): string {
  return typeof location === "undefined" ? href : domainHref(href, location.hostname);
}
